import Quill from "quill";
// import Delta from 'quill-delta';

var ClipboardBase = Quill.import("modules/clipboard");

const PATTERN_RENDER = /^{"render":/;

class Clipboard extends ClipboardBase {
  replaceEmoji = true;
  trim = true;
  
  onPaste(e) {
    e.preventDefault();
    let text = e.clipboardData.getData("text/plain");

    // Ignore Render
    if (PATTERN_RENDER.test(text)) return;

    // Prepare
    text = this.prepareText(text);

    // Replace
    // this.replaceWithNoStyle(text);
    this.replaceWithFirstStyle(text);
    // this.replaceWithLasttStyle(text);

    return;
  }

  prepareText(value) {
    value = value.replaceAll("\r\n", "\n").replaceAll("\r", "\n");
    if (this.replaceEmoji) value = this.removeEmoji(value);
    if (this.trim) value = value.trim();
    return value;
  }

  removeEmoji(value) {
    return value.replace(/(\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD10-\uDDFF])/g, '');
    // return value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
  }

  replaceWithNoStyle(value) {
    const range = this.quill.getSelection();

    this.quill.deleteText(range);
    this.quill.insertText(range, value);
  }
  replaceWithFirstStyle(value) {
    const range = this.quill.getSelection();

    this.quill.insertText({ index: range.index, length: 0 }, value); // prepended

    const rangeAfterIns = this.quill.getSelection();
    this.quill.deleteText(rangeAfterIns); // clear selected
  }
  replaceWithLasttStyle(value) {
    const range = this.quill.getSelection();

    this.quill.insertText({ index: range.index + range.length, length: 0 }, value); // appended

    this.quill.deleteText(range); // clear selected

    const rangeAfterClear = this.quill.getSelection();
    this.quill.setSelection({ index: rangeAfterClear.index + rangeAfterClear.length, length: 0 }); // cursor to last of appended
  }
}

export default Clipboard;